import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../layout/Layout.js';
import Section from '../../common/Section.js';
import Button from '../../common/Button.js';
import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

const ThankYouContainer = styled.div`
  text-align: center;
  max-width: 700px;
  margin: 0 auto;
  padding: 3rem 1rem;
`;

const ThankYouIcon = styled.div`
  font-size: 5rem;
  color: var(--secondary);
  margin-bottom: 2rem;
  animation: fadeIn 1s ease-in-out;
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const ThankYouTitle = styled.h1`
  color: var(--primary);
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
`;

const ThankYouMessage = styled.p`
  color: var(--gray);
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const ButtonContainer = styled.div`
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const ThankYouPage = () => {
  // For Google Analytics tracking (if implemented)
  React.useEffect(() => {
    // This would be the place to add Google Analytics event tracking
    // Example: window.gtag('event', 'conversion', {'send_to': 'AW-123456789/AbC-D_efG-h12_34-567'});
  }, []);
  
  return (
    <Layout>
      <Section>
        <ThankYouContainer>
          <ThankYouIcon>
            <FaCheckCircle />
          </ThankYouIcon>
          <ThankYouTitle>Thank you for reaching out to Shoffner Homes!</ThankYouTitle>
          <ThankYouMessage>
            We've received your message and will be in touch shortly.<br />
            If your request is urgent, please call us directly at <a href="tel:3365166716">(336) 516-6716</a>.
          </ThankYouMessage>
          <ButtonContainer>
            <Button as={Link} to="/" variant="secondary">
              Back to Home
            </Button>
            <Button as={Link} to="/homes-for-sale" variant="outline">
              View Available Homes
            </Button>
            <Button as={Link} to="/land-development" variant="outline">
              Explore Our Projects
            </Button>
          </ButtonContainer>
        </ThankYouContainer>
      </Section>
    </Layout>
  );
};

export default ThankYouPage;